import { Chip } from '@mui/material';
import classNames from 'classnames';
import { AutocompleteChipsRendererProps } from './autocompleteChipsRenderer.types';

function AutocompleteChipsRenderer<T>({
  value,
  getTagProps,
  getLimitTags,
  handleGetOptionLabel,
  tagClasses,
  defaultOptionsClasses,
  size,
  handleToggleInput,
  valuesWithError = undefined,
  isOptionEqualToValue,
}: AutocompleteChipsRendererProps<T>) {
  const limitTags = getLimitTags();
  const limitValue = (limitTags ?? 0) > 0 ? limitTags : value.length;
  const limitedValue = value.slice(0, limitValue ?? value.length);
  const hidden = value.slice(limitValue, value.length);

  const handleClickToOpenMenu = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    handleToggleInput();
  };

  return (
    <>
      {limitedValue.map((option: T, index: number) => {
        const labelText = handleGetOptionLabel(option);

        const { className: defaultChipClassName, ...restChipProps } = getTagProps({ index });

        const hasError = valuesWithError?.some((errorValue) =>
          isOptionEqualToValue(option, errorValue),
        );

        const finalChipClassName = classNames(defaultChipClassName, tagClasses, {
          [defaultOptionsClasses.limitedChip]: true,
        });

        return (
          <Chip
            {...restChipProps}
            key={`chip-${index}-${(option as { id?: string }).id || labelText}`}
            label={labelText}
            title={labelText}
            onClick={handleClickToOpenMenu}
            style={{
              maxWidth: 'calc(100% - 24px)',
              backgroundColor: hasError ? '#D32F2F1A' : undefined,
              border: hasError ? '0.5px solid #D32F2F1A' : undefined,
              color: hasError ? '#242424' : undefined,
            }}
            className={finalChipClassName}
            size={size}
            deleteIcon={
              hasError ? (
                <div
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    backgroundColor: '#D32F2F',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span style={{ color: 'white', fontSize: '14px' }}>×</span>
                </div>
              ) : undefined
            }
          />
        );
      })}

      {hidden.length > 0 && (
        <span
          onClick={handleClickToOpenMenu}
          title={hidden.map(handleGetOptionLabel).join('\n')}
          style={{ cursor: 'pointer' }}
        >
          +{hidden.length}
        </span>
      )}
    </>
  );
}

export default AutocompleteChipsRenderer;
